import React from 'react';
import { useHistory } from 'react-router-dom';
import style from './style/Collection.module.css';

const Collection = (props) => {
    const history = useHistory();
    
    const get = (e) =>{
        history.push('/products',e.target.value);
    }  

    return (
        <>
            <div className={style.cbox}>
                <ul>
                   <li key='0'><button value='All Products' onClick={get} >All Category</button></li>
                   <li key='1'><button value='Saree' onClick={get}>Saree</button></li>
                   <li key='2'><button value='Jeans' onClick={get}>Jeans</button></li>
                   <li key='3'><button value='Skirt' onClick={get}>Skirt</button></li>
                   <li key='4'><button value='Top' onClick={get}>Top</button></li> 
                  
                </ul>
            </div>
        </>
    )
}

export default Collection;
